import { render, staticRenderFns } from "./FormCustomizationSection.vue?vue&type=template&id=2a7fc17c&scoped=true&"
import script from "./FormCustomizationSection.vue?vue&type=script&lang=js&"
export * from "./FormCustomizationSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a7fc17c",
  null
  
)

export default component.exports